import { useMemo } from "react";

import { useGetPracticeCrops } from "utils";

import { CropYear } from "pages/app/scenario-analysis/types/scenario";
import { buildMainCropLabelLookup, buildSilverModelMainCropSelectOptions, getSelectedMainCropIds } from "pages/app/scenario-analysis/utils/scenarioOptions";

const NO_YEARS: CropYear[] = [];

/** Display names for every practice crop and whether the crop list has loaded; for screens that only name crops. */
export const useMainCropLabelLookup = () => {
  const { data: practiceCrops, isFetched } = useGetPracticeCrops({ enabled: true });
  const mainCropLabelLookup = useMemo(() => buildMainCropLabelLookup(practiceCrops), [practiceCrops]);

  return { mainCropLabelLookup, isPracticeCropsFetched: isFetched };
};

/** Main crop select options for a rotation (Silver-model crops plus any crop it already uses) and display names for every practice crop. */
export const useMainCropOptions = (rotationYears: CropYear[] = NO_YEARS) => {
  const { data: practiceCrops, isFetching } = useGetPracticeCrops({ enabled: true });

  const selectedCropIds = useMemo(() => getSelectedMainCropIds(rotationYears), [rotationYears]);
  const mainCropOptions = useMemo(() => buildSilverModelMainCropSelectOptions(practiceCrops, selectedCropIds), [practiceCrops, selectedCropIds]);
  const mainCropLabelLookup = useMemo(() => buildMainCropLabelLookup(practiceCrops), [practiceCrops]);

  return { practiceCrops, mainCropOptions, mainCropLabelLookup, isPracticeCropsFetching: isFetching };
};
